const mergeAssignmentsWithGrades = ({ assignments, studentGrades }) =>
  assignments.map(({ id, ...restAssignment }) => ({
    ...restAssignment,
    id,
    ...(studentGrades[id] && { studentGrade: studentGrades[id] }),
  }));

export default mergeAssignmentsWithGrades;
